// extracted by mini-css-extract-plugin
export default {"desktopmin":"1000px","mobilemax":"999px","NoticeBanner":"_NoticeBanner--Mbm1V","NoticeBannerMobile":"_NoticeBannerMobile--Jwvtd","IconContainer":"_IconContainer--YaDTe"};